<template>
  <div class="refresh-load">
    <div class="spinner">
      <div v-for="item in rectlist" :key="item" :class="`rect${item}`" :style="{'background-color': color}"></div>
    </div>
    <div class="spinner-text" v-if="text" :style="{'color': textColor}">{{text}}</div>
  </div>
</template>

<script>
export default {
  name: 'refreshLoading',
  props: ['text', 'color', 'textColor'],
  data() {
    return {
      rectlist: [1, 2, 3, 4, 5],
    }
  }
}
</script>

<style lang="scss" scoped>
.refresh-load{
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  box-sizing: border-box;
}
.spinner-text{
  height: .4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: .2rem;
  text-align: center;
}
.spinner {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 30px;
  height: 21px;
  text-align: center;
  font-size: .2rem;
}

.spinner > div {
  height: 100%;
  width: 3px;
  display: block;
  -webkit-animation: stretchdelay 1.2s infinite ease-in-out;
  animation: stretchdelay 1.2s infinite ease-in-out;
  background: #337FFF;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4) }
  20% { -webkit-transform: scaleY(1.0) }
}

@keyframes stretchdelay {
  0%, 40%, 100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% {
    transform: scaleY(1.0);
    -webkit-transform: scaleY(1.0);
  }
}
</style>
